export enum PaymentApp {
  GooglePay = 'google_pay',
  Paytm = 'paytm',
  PhonePe = 'phonepe',
  PaytmUpi = 'paytm_upi',
  Simpl = 'simpl',
  Amazon = 'amazonpay',
  Lazypay = 'lazypay',
  Card = 'card',
  Netbanking = 'netbanking',
  AmazonWallet = 'amazonpay_wallet',
  LazypayWallet = 'lazypay_wallet',
  Wallet = 'wallet',
  Mobikwik = 'mobikwik',
  Credit = 'credit',
  Debit = 'debit'
}
